module.exports = __webpack_public_path__ + "img/icon-guess@3x.a1e8d6d6.png";